<template>
  <div class="SaveProjectModal">
    <el-dialog
        title="编辑项目"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
    >
      <el-form
          ref="form"
          :rules="rules"
          :model="formData"
          size="mini"
          label-width="90px">
        <el-form-item label="选择课包" prop="productId">
          <el-select
              ref="productRef"
              v-model="formData.productId"
              v-scroll="loadMoreProduct"
              placeholder="请选择"
              @change="productIdChange"
              @click.native="productIdNameInit"
          >
            <el-option
                v-for="item in productIdNameList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="name">
          <el-input
              v-model="formData.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="默认课程分值占比">
          <el-input-number
              v-model="formData.projectConfig.lessonWeight"
              :precision="0"
              :step="10"
              :min="0"
              :max="100"
              size="small"
              @change="lessonWeightChange"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="默认试题分值占比">
          <el-input-number
              v-model="formData.projectConfig.testWeight"
              :precision="0"
              :step="10"
              :min="0"
              :max="100"
              size="small"
              @change="testWeightChange"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="标签选择">
          <AppTreeSelect
              :options="options"
              :valueArr="selectedTagIds"
              @check="handleTagCheck"
          ></AppTreeSelect>
        </el-form-item>
        <el-form-item v-show="formData.projectConfig.tagConfigs?.length" label="分值占比">
          <div style="display: flex" v-for="(item,index) in formData.projectConfig.tagConfigs">
            <div style="display: flex;width: 120px">{{ item.name }}</div>
            <div>
              <el-form-item label="课程">
                <el-input-number
                    v-model="item.lessonWeight"
                    :precision="0"
                    :step="10"
                    :min="0"
                    :max="100"
                    size="small"
                    @change="(value)=>{tagLessonWeightChange(value, item)}"
                ></el-input-number>
              </el-form-item>
              <el-form-item label="试题">
                <el-input-number
                    v-model="item.testWeight"
                    :precision="0"
                    :step="10"
                    :min="0"
                    :max="100"
                    size="small"
                    @change="(value)=>{tagTestWeightChange(value, item)}"
                ></el-input-number>
              </el-form-item>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button type="primary" @click="handleSaveEvaluation">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex";
import AppTreeSelect from "@/components/ui/AppTreeSelect/index.vue";

export default {
  name: "SaveProjectModal",
  props: {},
  components: {AppTreeSelect},
  mixins: [],
  data() {
    let defaultFormData = this.defaultFormData();
    return {
      visible: false,
      formData: defaultFormData,
      productList: {
        page: 0,
        size: 10,
        total: null
      },
      productIdNameList: [],
      rules: {
        productId: [
          {
            required: true,
            message: "请选额",
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "请输入",
            trigger: ["blur", "change"],
          },
        ],
      },
      options: [],
      selectedTagIds: []
    };
  },
  watch: {},
  computed: {
    ...mapState("courseCenter", ["tagCategoryList"]),
  },
  async mounted() {
    await this.getTagCategoryList({
      includeChild: true,
      page: 1,
      size: 10000,
    });
    this.options = this.tagCategoryList.data;
  },
  methods: {
    ...mapActions("projectCenter", ["saveEvaluation"]),
    ...mapActions("teachingCenter", ["getProductMapList"]),
    ...mapActions("courseCenter", ["getTagCategoryList"]),
    handleTagCheck(value, checked) {
      this.formData.projectConfig.tagConfigs = checked.checkedNodes.map(item => {
        if (item.children) return null;
        let find = this.formData.projectConfig.tagConfigs.find(tag => tag.id === item.id);
        if (find) return find;
        return {
          tagId: item.id,
          name: item.name,
          lessonWeight: 50,
          testWeight: 50,
        }
      }).filter(item => item)
    },
    tagLessonWeightChange(value, item) {
      item.testWeight = 100 - value;
    },
    tagTestWeightChange(value, item) {
      item.lessonWeight = 100 - value;
    },
    lessonWeightChange(value) {
      this.formData.projectConfig.testWeight = 100 - value;
    },
    testWeightChange(value) {
      this.formData.projectConfig.lessonWeight = 100 - value;
    },
    productIdNameInit() {
      if (this.productIdNameList.length === 0) {
        this.loadMoreProduct();
      }
    },
    productIdChange() {
      if (!this.formData.name) {
        let find = this.productIdNameList.find((item) => {
          return item.id === this.formData.productId
        });
        this.$set(this.formData, 'name', find.name)
      }
    },
    async loadMoreProduct() {
      const currentPage = this.productList.page;
      const currentSize = this.productList.size;
      const currentTotal = this.productList.total;
      if (currentTotal == null || currentPage * currentSize < currentTotal) {
        let productMapList = await this.getProductMapList({page: currentPage + 1});
        let data = productMapList.data;
        this.productList.page = data.page;
        this.productList.size = data.size;
        this.productList.total = data.total;
        let productList = data.data;
        productList.forEach((item) => {
          this.productIdNameList.push({id: item.id, name: item.name})
        })
      }
    },
    initData(data) {
      this.selectedTagIds = [];
      this.formData = this.defaultFormData();
      let map = new Map(this.options.flatMap(item => item.children).filter(item => item).map(item => [item.id, item.name]));
      if (data) {
        this.formData = {...data};
        data.projectConfig?.tagConfigs?.forEach(item => {
          this.selectedTagIds.push(item.tagId);
          item.name = map.get(item.tagId)
        });
        this.$nextTick(() => {
          this.$refs.productRef.selected = {value: data["productId"], currentLabel: data["productName"]};
          this.$refs.productRef.selectedLabel = data["productName"];
        })
      }
    },
    defaultFormData() {
      return {
        id: null,
        name: null,
        productId: null,
        projectConfig: {
          lessonWeight: 50,
          testWeight: 50,
          tagConfigs: []
        }
      }
    },
    async handleSaveEvaluation() {
      this.$refs.form.validate((flag) => {
        if (!flag) return;
        this.saveEvaluation(this.formData).then((res) => {
          this.$emit("evaluationSaved", res.data)
          this.visible = false;
        });
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.SaveProjectModal {
  width: 100%;

  .el-form-item__label {

  }
}
</style>
